import { render, staticRenderFns } from "./Emolumentos.vue?vue&type=template&id=453ab708"
import script from "./Emolumentos.vue?vue&type=script&lang=js"
export * from "./Emolumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453ab708')) {
      api.createRecord('453ab708', component.options)
    } else {
      api.reload('453ab708', component.options)
    }
    module.hot.accept("./Emolumentos.vue?vue&type=template&id=453ab708", function () {
      api.rerender('453ab708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Emolumentos.vue"
export default component.exports